import React from "react";
import classNames from "classnames";
import { IImportState } from "./useImportState";

interface IProcessingStepProps {
  importState: IImportState;
}

const ProcessingStep: React.FC<IProcessingStepProps> = ({ importState }) => {
  const { importProgress } = importState;

  const progressPercentage =
    importProgress.totalCount === 0
      ? 0
      : Math.round(
          (importProgress.processedCount / importProgress.totalCount) * 100,
        );

  return (
    <div className={classNames("p-8", "text-center")}>
      <div
        className={classNames(
          "w-full",
          "bg-gray-200",
          "rounded-full",
          "h-4",
          "mb-4",
        )}
      >
        <div
          className={classNames("bg-orange-500", "h-4", "rounded-full")}
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>

      <p className={classNames("font-medium")}>
        Importing contacts: {progressPercentage}% complete
      </p>
      <p className={classNames("text-sm", "text-gray-600", "mt-1")}>
        {importProgress.processedCount} of {importProgress.totalCount} contacts
        processed
      </p>

      {importProgress.errors.map((error, index) => (
        <div
          key={index}
          className={classNames(
            "mt-4",
            "p-3",
            "bg-red-50",
            "text-red-600",
            "text-sm",
            "rounded-md",
          )}
        >
          {error}
        </div>
      ))}

      <p className={classNames("text-sm", "text-gray-600", "mt-4")}>
        This may take a few moments. Please do not close this window.
      </p>
    </div>
  );
};

export default ProcessingStep;
